import * as ng from 'angular';
import { ILogger } from './logger';

interface IException {
    catcher(message: string): Function;
}

let ExceptionFactory: Function = function($q: ng.IQService, logger: ILogger): IException  {

        return new ExceptionService($q, logger);

        //let service = {
        //    catcher: catcher
        //};

        //return service;
    };

ExceptionFactory.$inject = ['$q', 'logger'];

class ExceptionService implements IException {

    constructor(private $q: ng.IQService, private logger: ILogger) {
        this.$q = $q;
        this.logger = logger;
    }

    public catcher(message: string): Function {
        return (e) => {
            var thrownDescription;
            var newMessage;
            if (e.data && e.data.description) {
                thrownDescription = '\n' + e.data.description;
                newMessage = message + thrownDescription;
            }
            e.data.description = newMessage;
            this.logger.error(newMessage);
            return this.$q.reject(e);
        };
    }

}

let Exception = {
    name: "exception",
    factory: ExceptionFactory
};

export { Exception, IException }
export default Exception;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/core/exception.ts